import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';

export const getOfferWithHighestSuitability = (
    getFormalOffersResponse: GetFormalOffersResponse
) => {
    const formalOffers = getFormalOffersResponse?.data?.formal_offers;
    if (!formalOffers || formalOffers.length === 0) {
        return null;
    }
    //assume if there is no suitability_info on the offer set, we would never need this logic
    if (!formalOffers[0].suitability_info) {
        return null;
    }
    return formalOffers.reduce((highest, current) => {
        return current.suitability_info!.suitability_score >
            highest.suitability_info!.suitability_score
            ? current
            : highest;
    }, formalOffers[0]);
};
